import { render } from "./ModalDetailNote.vue?vue&type=template&id=0d5e7b86&scoped=true"
import script from "./ModalDetailNote.vue?vue&type=script&lang=js"
export * from "./ModalDetailNote.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0d5e7b86"

export default script